import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TutorialState {
  /** Mostrar os tutoriais na primeira vez em cada tela. */
  enabled: boolean;
  /** Tutoriais já vistos (ou pulados), por usuário: `${userId}:${tourId}`. */
  seen: Record<string, true>;
  /** Tutorial aberto agora (pedido pelo botão "?"), mesmo que já visto. */
  replaying: string | null;
  markSeen: (key: string) => void;
  replay: (tourId: string) => void;
  stopReplay: () => void;
  setEnabled: (enabled: boolean) => void;
  /** Volta a mostrar todos os tutoriais. */
  reset: () => void;
}

export const useTutorial = create<TutorialState>()(
  persist(
    (set) => ({
      enabled: true,
      seen: {},
      replaying: null,
      markSeen: (key) => set((s) => ({ seen: { ...s.seen, [key]: true } })),
      replay: (tourId) => set({ replaying: tourId }),
      stopReplay: () => set({ replaying: null }),
      setEnabled: (enabled) => set({ enabled }),
      reset: () => set({ seen: {}, enabled: true }),
    }),
    { name: 'wg-tutorial', partialize: (s) => ({ enabled: s.enabled, seen: s.seen }) },
  ),
);
